<template>
  <div>
      <v-menu v-model="menuTime" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field v-model="model" :label="label" prepend-icon="event" readonly clearable v-on="on"></v-text-field>
        </template>

        <v-time-picker
          v-model="model"
          format="24hr"
          @input="menuTime = false"
          :landscape="true">
        </v-time-picker>
      </v-menu>
      
    <p>{{ description }}</p>
  </div>
</template>

<script>
import { input } from '@/mixins/input'
export default {
  mixins: [ input ],
  data(){
    return {
      menuTime : false
    }
  }
}
</script>

<style>
</style>
